import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOfferPositions Types */
import {
  _SupplierOfferPositions
} from '../namespace-helper'

import _ from 'lodash'

const selectedSupplierOfferPositionTemplate = {
  id: 0,
  product: {
    id: 0,
    reference: null,
    product_description: {}
  },
  delivery_time: {},
  discounts: [],
  unit_price: '0,00',
  suppliers_offer: {
    currency: {
      name: ''
    }
  }

}

const supplierOfferPositionTemplate = [
  {
    product: {
      product_description: {}
    },
    delivery_time: {},
    discounts: [],
    unit_price: '0,00'
  }

]

export default {
  namespaced: true,
  state: {
    selectedSupplierOfferPosition: _.cloneDeep(selectedSupplierOfferPositionTemplate),
    supplierOfferPosition: [
      {
        product: {
          product_description: {}
        },
        delivery_time: {},
        discounts: [],
        unit_price: '0,00'
      }

    ],
    supplierOfferPositions: [],
    supplierOfferPositionsBySupplierOffer: [],
    supplierOfferPositionLoading: false,
    supplierOfferPositionSaving: false,
    supplierOfferPositionDiscountRemoving: false,
    supplierOfferPositionPrice: '0.00',
    openDialog: false
  },
  mutations: {
    [_SupplierOfferPositions.mutations.setSupplierOfferPosition] (state, payload) {
      if (payload.length >= 1) {
        state.supplierOfferPosition = payload
      } else {
        state.supplierOfferPosition = _.cloneDeep(supplierOfferPositionTemplate)
      }
    },
    [_SupplierOfferPositions.mutations.setSelectedSupplierOfferPosition] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOfferPosition = payload
      } else {
        state.selectedSupplierOfferPosition = _.cloneDeep(selectedSupplierOfferPositionTemplate)
      }
    },
    [_SupplierOfferPositions.mutations.setSupplierOfferPositions] (state, payload) {
      state.supplierOfferPositions = payload
    },
    [_SupplierOfferPositions.mutations.setSupplierOfferPositionsBySupplierOffer] (state, payload) {
      state.supplierOfferPositionsBySupplierOffer = payload
    },
    [_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition] (state, payload) {
      state.supplierOfferPositionLoading = payload
    },
    [_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition] (state, payload) {
      state.supplierOfferPositionDiscountRemoving = payload
    },
    [_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition] (state, payload) {
      state.supplierOfferPositionSaving = payload
    },
    [_SupplierOfferPositions.mutations.setSupplierOfferPositionPrice] (state, payload) {
      state.supplierOfferPositionPrice = payload
    },
    [_SupplierOfferPositions.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_SupplierOfferPositions.actions.saveSupplierOfferPosition] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition, true)

      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOfferPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOfferPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            context.commit(_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition, false)
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            context.commit(_SupplierOfferPositions.mutations.setSavingSupplierOfferPosition, false)
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOfferPositions.actions.loadSupplierOfferPositionBySupplierOfferAndInquiryPositionID] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositions/supplierOffer/' + payload.suppliers_offers_id + '/' + payload.inquiries_positions_id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPosition, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPosition, null)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.loadSupplierOfferPositionsBySupplierOffer] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositions/supplierOffer/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositionsBySupplierOffer, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositionsBySupplierOffer, [])
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.loadSupplierOfferPositionByProductID] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositions/product/' + payload + '?orderBy=suppliers_offers:suppliers_offers_id|suppliers_offers.valid_until&sortedBy=desc'

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositions, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositions, [])
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.loadSupplierOfferPositionByProductIDIndex] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositions/product/' + payload.id + '/index?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;suppliersOffer.offer_number:like;suppliersOffer.supplier.name:like;unit_price:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositions, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setLoadSupplierOfferPosition, false)
          context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositions, [])
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.removeSupplierOfferPositionDiscount] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositionDiscounts/' + payload

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    // todo move it to another file
    [_SupplierOfferPositions.actions.getProductsWithPrices] (context, payload) {
      console.log('getProductsWithPrices: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/productListingPriceCalculations/product/' + payload.reference_id

      return new Promise((resolve, reject) => {
        return axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.deleteSupplierOfferPosition] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, true)

      var url = API_URL + '/api/v1/supplierOfferPositions/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOfferPositions.mutations.setRemovingSupplierOfferPosition, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOfferPositions.actions.setSupplierOfferPosition] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPosition, payload)
    },
    [_SupplierOfferPositions.actions.setSelectedSupplierOfferPosition] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setSelectedSupplierOfferPosition, payload)
    },
    [_SupplierOfferPositions.actions.setSupplierOfferPositionPrice] (context, payload) {
      context.commit(_SupplierOfferPositions.mutations.setSupplierOfferPositionPrice, payload)
    },
    [_SupplierOfferPositions.actions.openCloseDialog] ({ commit }) {
      commit(_SupplierOfferPositions.mutations.setOpenCloseDialogState)
    },
    [_SupplierOfferPositions.actions.resetState] ({ commit }) {
      commit(_SupplierOfferPositions.mutations.setSupplierOfferPositions, [])
      commit(_SupplierOfferPositions.mutations.setSupplierOfferPosition, [])
      commit(_SupplierOfferPositions.mutations.setSupplierOfferPositionsBySupplierOffer, [])
      commit(_SupplierOfferPositions.mutations.setSupplierOfferPositionPrice, '0,00')
      commit(_SupplierOfferPositions.mutations.setSelectedSupplierOfferPosition, null)
    }

  },
  getters: {
    [_SupplierOfferPositions.getters.getSupplierOfferPosition] (state) {
      return state.supplierOfferPosition
    },
    [_SupplierOfferPositions.getters.getSelectedSupplierOfferPosition] (state) {
      return state.selectedSupplierOfferPosition
    },
    [_SupplierOfferPositions.getters.getSupplierOfferPositions] (state) {
      return state.supplierOfferPositions
    },
    [_SupplierOfferPositions.getters.getSupplierOfferPositionsBySupplierOffer] (state) {
      return state.supplierOfferPositionsBySupplierOffer
    },
    [_SupplierOfferPositions.getters.getLoadingSupplierOfferPosition] (state) {
      return state.supplierOfferPositionLoading
    },
    [_SupplierOfferPositions.getters.getSavingSupplierOfferPosition] (state) {
      return state.supplierOfferPositionSaving
    },
    [_SupplierOfferPositions.getters.getRemovingSupplierOfferPositionDiscount] (state) {
      return state.supplierOfferPositionDiscountRemoving
    },
    [_SupplierOfferPositions.getters.getSupplierOfferPositionPrice] (state) {
      return state.supplierOfferPositionPrice
    },
    [_SupplierOfferPositions.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOfferPosition/supplierOfferPositions.js